import React from 'react';
import Input from '../../forms/Input';
import { PATH } from '../util/paths';
import i18n from '../../../common/i18n';

const EmailInput = ({ form, setInput }) => {
    return (
        <Input
            form={form}
            path={PATH.EMAIL_CODE}
            label={i18n('nui.two.fa.label.email')}
            autocomplete="email_code"
            type="text"
            autocapitalize="off"
            onInput={e => setInput(e.target.value)}
            dataAtid="text-form-input-email"
        />
    );
};

export default EmailInput;
